import { useState } from 'react';

import { Alert, Button, Checkbox, CopyButton, Group, SimpleGrid, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

/**
 * The recovery codes of the second factor (08 §2.10), shown once: each opens one session when the
 * phone is lost. The person confirms they kept them before the flow moves on.
 */
export function RecoveryCodesPanel({
  codes,
  continueLabel,
  onContinue,
}: {
  codes: string[];
  continueLabel: string;
  onContinue: () => void;
}) {
  const { t } = useTranslation('auth');
  const [saved, setSaved] = useState(false);
  const text = codes.join('\n');

  const download = () => {
    const url = URL.createObjectURL(new Blob([text + '\n'], { type: 'text/plain' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'serviceledger-codigos-de-recuperacion.txt';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Stack gap="md">
      <Alert color="yellow" variant="light">
        {t('mfa.codes.warning')}
      </Alert>
      <SimpleGrid cols={2} spacing="xs" aria-label={t('mfa.codes.title')} role="list">
        {codes.map((code) => (
          <Text key={code} ff="monospace" size="sm" role="listitem">
            {code}
          </Text>
        ))}
      </SimpleGrid>
      <Group gap="xs">
        <CopyButton value={text}>
          {({ copied, copy }) => (
            <Button variant="light" size="xs" onClick={copy}>
              {copied ? t('mfa.codes.copied') : t('mfa.codes.copy')}
            </Button>
          )}
        </CopyButton>
        <Button variant="light" size="xs" onClick={download}>
          {t('mfa.codes.download')}
        </Button>
      </Group>
      <Checkbox
        label={t('mfa.codes.saved')}
        checked={saved}
        onChange={(event) => setSaved(event.currentTarget.checked)}
      />
      <Button onClick={onContinue} disabled={!saved}>
        {continueLabel}
      </Button>
    </Stack>
  );
}
